import { useNetInfo } from "@react-native-community/netinfo";
export function isOffline(networkStatus) {
  return networkStatus.type !== "unknown" && typeof networkStatus.isInternetReachable === "boolean" && networkStatus.isConnected === false;
}
export function useIsOffline() {
  return isOffline(useNetInfo());
}
